/*
 * Copyright (c) 2022. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

// models and services
import { CanAffordHome, CanAffordPurchase } from '../../services/finance.service';
import { CanAffordViewModel } from 'src/types/view-models/can-afford.view.model';

// stylesheets and icons
import StatusCallout from '../callout/StatusCallout';

export default class CanAfford extends Component<CanAffordViewModel> {
    public override render(): ReactComponentElement<any> {
        switch (this.props.canAfford) {
            case CanAffordHome.ok:
            case CanAffordPurchase.ok:
                return (
                    <div className={this.props.className}>
                        <StatusCallout status="success" icon="check" text="We think you can afford this." />
                    </div>
                );

            case CanAffordHome.useSavings:
            case CanAffordPurchase.useSavings:
                return (
                    <div className={this.props.className}>
                        <StatusCallout
                            status="warning"
                            icon="check"
                            text="We think you can afford this if you dip into your savings."
                        />
                    </div>
                );

            case CanAffordPurchase.tooExpensive:
                return (
                    <div className={this.props.className}>
                        <StatusCallout status="error" icon="warning" text="We don’t think you can afford this." />
                    </div>
                );

            case CanAffordHome.downPaymentTooHigh:
                return (
                    <div className={this.props.className}>
                        <StatusCallout
                            status="error"
                            icon="warning"
                            text="We don’t think you can afford this down payment."
                        />
                    </div>
                );

            case CanAffordHome.monthlyAndDownPaymentTooHigh:
                return (
                    <div className={this.props.className}>
                        <StatusCallout
                            status="error"
                            icon="warning"
                            text="We don’t think you can afford this down payment and monthly payment."
                        />
                    </div>
                );

            case CanAffordHome.monthlyPaymentTooHigh:
                return (
                    <div className={this.props.className}>
                        <StatusCallout
                            status="error"
                            icon="warning"
                            text="We don’t think you can afford this monthly payment."
                        />
                    </div>
                );
        }
    }
}
